export default __webpack_public_path__ + "static/media/GuideLakeSection.2e70e9fd.png";